// @flow

import React from 'react';
import PlayButton from './PlayButton';
import './VideoPlayerButton.css';

const VideoPlayerButton = () => (
  <div
    className='icon video-player-button'
  >
    <div>
      <PlayButton />
    </div>
  </div>
);

export default VideoPlayerButton;
